import { render, staticRenderFns } from "./ActivationNotice.vue?vue&type=template&id=85179b38&"
import script from "./ActivationNotice.vue?vue&type=script&lang=ts&"
export * from "./ActivationNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports